module.exports = __webpack_public_path__ + "static/media/TEN.d2655f80.png";